// extracted by mini-css-extract-plugin
export default {"section":"LiveMonitorStats_section__TCcEE","grid":"LiveMonitorStats_grid__8fNm9"};